module.exports = __webpack_public_path__ + "img/3.87daa240.jpeg";